import { BlockSuiteEditor } from './blocksuite-react-editor'

export type DocMode = 'page' | 'edgeless'

interface SimpleBlockSuiteEditorProps {
  documentId: string
  mode?: DocMode
  onContentChange?: (content: any) => void
}

export function SimpleBlockSuiteEditor({ 
  documentId,
  mode = 'page',
  onContentChange
}: SimpleBlockSuiteEditorProps) {
  return (
    <BlockSuiteEditor
      documentId={documentId}
      mode={mode}
      onContentChange={onContentChange}
    />
  )
}